import { Extension } from '@tiptap/vue-3';

declare module '@tiptap/vue-3' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Commands<ReturnType> {
    lineSpacing: {
      /**
       * set the line spacing in any valid css unit
       * @example editor.commands.setLineSpacing('2rem')
       */
      setLineSpacing: (spacing: string) => ReturnType;
      /**
       * Unset the line spacing attribute
       */
      unsetLineSpacing: () => ReturnType;
    };
  }
}

export default Extension.create({
  name: 'lineSpacing',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph'],
        attributes: {
          lineSpacing: {
            // default: this.options.defaultSpacing,
            parseHTML: (element) => {
              return element.style.lineHeight;
            },
            renderHTML: (attributes) => {
              const lineHeight: unknown = attributes.lineSpacing;
              if (lineHeight && typeof lineHeight === 'string') {
                return { style: `line-height: ${lineHeight}` };
              } else {
                return {};
              }
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setLineSpacing:
        (spacing: string) =>
        ({ commands }) => {
          return commands.updateAttributes('paragraph', {
            lineSpacing: spacing,
          });
        },

      unsetLineSpacing:
        () =>
        ({ commands }) => {
          return commands.resetAttributes('paragraph', 'lineHeight');
        },
    };
  },
});
